import Swiper from 'swiper';
import { Navigation, Scrollbar } from 'swiper/modules';
Swiper.use([Navigation, Scrollbar]);

export const initSwiper = () => {
    const sliderBlocks = document.querySelectorAll('.section--slider');
  
    if (sliderBlocks.length > 0) {
        Array.from(sliderBlocks).forEach((sectionSlider) => {
            const currentSwiper = sectionSlider?.querySelector(".swiper-container") as HTMLElement;
            const currentSwiperScrollbar = sectionSlider?.querySelector(".swiper-scrollbar") as HTMLElement;
            const currentNextEl = sectionSlider?.querySelector(".slider-nav--next") as HTMLButtonElement;
            const currentPrevEl = sectionSlider?.querySelector(".slider-nav--prev") as HTMLButtonElement;
            const sliderBlockSwiper = new Swiper(currentSwiper, {
                scrollbar: {
                    el: currentSwiperScrollbar,
                    draggable: true,
                },
                navigation: {
                    nextEl: currentNextEl,
                    prevEl: currentPrevEl,
                },
                keyboard: {
                    enabled: true,
                },
                breakpoints: {
                    320: {
                        slidesPerView: "auto",
                        spaceBetween: 20,
                    },
                },
            });
        });
    }
   
    const carouselContainer = document.getElementById("myCarousel");
    if (carouselContainer) {
        const swiperSlider = new Swiper('.swiper', {
            loop: true,
            navigation: {
                nextEl: '.slider-nav--next',
                prevEl: '.slider-nav--prev',
            },
            keyboard: {
                enabled: true,
            },
            breakpoints: {
                320: {
                    slidesPerView: "auto",
                    spaceBetween: 20,
                },
            },
        });
    }

}